import { render, staticRenderFns } from "./price_shirka.vue?vue&type=template&id=68f2bcfa&scoped=true&"
import script from "./price_shirka.vue?vue&type=script&lang=js&"
export * from "./price_shirka.vue?vue&type=script&lang=js&"
import style0 from "./price_shirka.vue?vue&type=style&index=0&id=68f2bcfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f2bcfa",
  null
  
)

export default component.exports